import {
  CMSApiBase,
  CMSDescription,
  CMSFaq,
  CMSHowToParticipate,
  CMSImageBase,
  createCmsUrl,
} from './base';
import { fetcherCMS } from '@/modules/api';
import { getCMSImageFieldsUrl, getCMSLocale } from '@/modules/cms';

export interface FortuneWheelMenuDataApi extends CMSApiBase {
  pageTitle: string;
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
    reward: string;
    dailySpins: string;
    tryTomorrow: string;
  };
}

export const getFortuneWheelMenuCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: {
      ...getCMSLocale(lang),
      populate: {
        menu: {
          populate: {
            ...getCMSImageFieldsUrl('bg'),
            ...getCMSImageFieldsUrl('character'),
          },
        },
      },
      fields: ['page_title'],
    },
  });

export const getFortuneWheelCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const getFortuneWheelPageTitleCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'fortune-wheel',
    queryData: {
      ...getCMSLocale(lang),
      fields: ['page_title'],
    },
  });

export const fetchFortuneWheelMenuCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelMenuDataApi>(
    getFortuneWheelMenuCMSUrl(lang)
  );
  return { data: response };
};

export interface FortuneWheelApi extends CMSApiBase {
  pageTitle: string;
  description: CMSDescription[];
  howToParticipateTitle: string;
  leftCharacter: CMSImageBase;
  rightCharacter: CMSImageBase;
  mobileCharacter: CMSImageBase;
  leftDecor: CMSImageBase;
  rightDecor: CMSImageBase;
  wheelArrow: CMSImageBase;
  topBg: CMSImageBase;
  howToParticipate: CMSHowToParticipate[];
  faq: CMSFaq[];
  bonusBuyPromocode?: string;
  wheel: {
    active: CMSImageBase;
    spinning: CMSImageBase;
    finished: CMSImageBase;
  };
}

export const fetchFortuneWheelCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelApi>(
    getFortuneWheelCMSUrl(lang)
  );
  return { data: response };
};

export interface FortuneWheelPageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const fetchFortuneWheelPageTitleCMS = async (lang: string) => {
  const response = await fetcherCMS<FortuneWheelPageTitleApi>(
    getFortuneWheelPageTitleCMSUrl(lang)
  );
  return { data: response };
};
